import React from 'react';

import { ReactProps } from '../../../typings/common-types';

import Icon, { IIcon } from './icon';

const svg = (props: ReactProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 126 126" {...props}>
    <path
      d="M107.502 0c10.197 0 18.499 8.3 18.499 18.497v89.006c0 10.196-8.302 18.497-18.499 18.497H18.498C8.301 126 0 117.7 0 107.503V18.497C0 8.301 8.301 0 18.498 0Zm9.69 43.146H8.809v64.357c0 5.341 4.348 9.689 9.69 9.689h89.003c5.342 0 9.69-4.348 9.69-9.69V43.147ZM62 89c2.201 0 4 1.792 4 4s-1.799 4-4 4c-2.208 0-4-1.792-4-4s1.792-4 4-4Zm31 0c2.208 0 4 1.792 4 4s-1.792 4-4 4-4-1.792-4-4 1.792-4 4-4Zm-60 0c2.208 0 4 1.792 4 4s-1.792 4-4 4-4-1.792-4-4 1.792-4 4-4Zm60-25c2.208 0 4 1.792 4 4s-1.792 4-4 4-4-1.792-4-4 1.792-4 4-4Zm-31 0c2.201 0 4 1.792 4 4s-1.799 4-4 4c-2.208 0-4-1.792-4-4s1.792-4 4-4Zm-29 0c2.208 0 4 1.792 4 4s-1.792 4-4 4-4-1.792-4-4 1.792-4 4-4Zm74.501-55.192H18.498c-5.341 0-9.69 4.348-9.69 9.69v15.84h108.384v-15.84c0-5.342-4.348-9.69-9.69-9.69Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

const IconCalendar = (props: IIcon & ReactProps) => <Icon {...props} svg={svg} />;

export default IconCalendar;
